module.exports = __webpack_public_path__ + "img/coming_soon_br.04b806d2.svg";